import Quill from 'quill'
import {MAP_PARAM_OPERATOR} from '../index'
import {getRandomId} from '../../../../utils'

const Parchment = Quill.imports.parchment

export class MapParamOperator extends Parchment.Embed {
    static tagName = 'span'
    static blotName = MAP_PARAM_OPERATOR
    static className = MAP_PARAM_OPERATOR

    // eslint-disable-next-line no-useless-constructor
    constructor(domNode) {
        super(domNode)
    }

    static register() {
        Quill.register(MapParamOperator)
    }

    static create({operator = ' '}) {
        const node = super.create(operator)
        node.id = getRandomId('tag')
        node.innerText = operator
        node.contentEditable = 'false'
        node.dataset[_.camelCase(MAP_PARAM_OPERATOR)] = 'true'
        return node
    }

    static value(node) {
        return node.childNodes[0].textContent
    }
}
